export default function CardHeader(props) {
  const {className, ...restProps} = props

  return (
    <div className={classNames("components-card-header", className)} {...restProps} />
  )
}
